<template>
    <main class="min-h-screen w-full bg-[radial-gradient(1200px_500px_at_50%_0%,#0e2e6f_0%,#041a43_45%,#031837_100%)] flex items-center justify-center px-4 py-6 sm:px-6 sm:py-10">
        <div>
            <iframe
                :src="iframeSrc"
                class="md:w-[448px] h-[80vh] rounded-lg"
                :title="iframeTitle"
                loading="lazy"
                referrerpolicy="strict-origin-when-cross-origin"
                allow="clipboard-write"
            />
        </div>
    </main>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    iframeTitle: { type: String, required: true },
    formIds: {
        type: Object,
        required: true
    }
});

const getEnvironment = () => {
    const host = window.location.hostname.toLowerCase();

    if (host.endsWith('.test')) return 'local';

    if (host.includes('staging')) return 'staging';

    if (host.includes('dev')) return 'dev';

    if (host.includes('hkcmanagement.de')) return 'production';

    return 'staging';
};

const currentEnvironment = computed(() => getEnvironment());

const currentFormId = computed(() => props.formIds[currentEnvironment.value] || props.formIds.local || props.formIds.staging || props.formIds.dev || '');

const iframeSrc = computed(() => `https://actions.hkcm-ifs.de/form/${currentFormId.value}`);
</script>
